import {
  FeaturesSection,
  ProductPagesHOC,
} from "../components/product-pages-new";
import { websiteDomain, dashboardDomain } from "../constants/domain";

const faqs = [
  {
    q: "How does users join my Telegram groups or channels?",
    a: "After successful payment, the users will receive a unique one-time joining link of the Telegram private channel on their registered number through WhatsApp and SMS.",
  },
  {
    q: "Can we automate our existing Telegram group or channel?",
    a: `A big <b>YES!</b> You can follow some basic steps on the qoohoo app to automate your existing Telegram channels and start monetizing your audience.`,
  },
  {
    q: "Do my users need to install qoohoo app?",
    a: `Users don't have to download or install the qoohoo app. They can complete the payment on the web browsers and join the telegram channels with the invite links received after the payments.`,
  },
  {
    q: "How can I withdraw money in my bank account?",
    a: "Instant payout is available in profile section of the app. You can withdraw your money as soon as it touches 1000 INR.",
  },
  {
    q: "Where can I see my user and payment details?",
    a: "Creators can visit the telegram channel page on the qoohoo app and view details like members list, earnings, and link clicks to track their data.",
  },
];

const pageConfig = {
  seo: {
    title: "Telegram Payments • qoohoo",
    description:
      "Launch your paid Telegram channels and groups with no hassle. Automatically add and remove your users with qoohoo Telegram payments. Manage your community members effectively with automatic reminders for your Telegram recurring subscription with qoohoo. Telegram automatic payments, management and discounts - all at one place.",
    url: `${websiteDomain}/telegram-payments`,
    ogImageAsset: "/assets/images/telegram-payments-og-image.png",
  },
  hero: {
    filler: {
      iconLeft: "/assets/icons/star-blue-hollow.svg",
      iconRight: "/assets/icons/atm-card.svg",
    },
    heading: (
      <>
        Start paid subscription
        <br />
        <span>
          on <span className="text-[#2AABEE]">Telegram</span>
        </span>
      </>
    ),
    headingImage: "/assets/icons/telegram.svg",
    headingAnnotationIcon: "/assets/icons/annotation.svg",
    description:
      "Automate your Telegram channel in just three steps and manage your payments with no hassle",
    buttonText: "Create your channel",
    onButtonClick: () => {
      window.open(`${dashboardDomain}/creator-onboarding`, "_blank");
    },
  },
  process: {
    headingIcon: "/assets/images/telegram-payments-process-arrow.png",
    heading: "Super Fast Process",
    description: "Launch your paid Telegram Subscription in less than 60 sec",
    video: {
      src: "https://youtu.be/VtDpo9nDXlQ",
      type: "video/youtube",
    },
  },
  features: {
    heading: "Our features",
    items: [
      {
        icon: "/assets/icons/users.svg",
        title: "Manage your users",
        description:
          "Users will be auto-added, removed & get reminded about their subscription",
        image: {
          desktop: "/assets/images/telegram-payments-manage-user.png",
          mobile: "/assets/images/telegram-payments-manage-user.png",
        },
        type: FeaturesSection.CARD_TYPES.VERTICAL,
      },
      {
        icon: "/assets/icons/ticket-star.svg",
        title: "Plans & discounts",
        description:
          "Offer your members multiple plans with customised discounts in a single link",
        image: {
          desktop: "/assets/images/telegram-payments-select-plan.png",
          mobile: "/assets/images/telegram-payments-select-plan.png",
        },
        type: FeaturesSection.CARD_TYPES.VERTICAL,
      },
      {
        icon: "/assets/icons/chat.svg",
        title: "Users retargeting",
        description:
          "Retarget your customers directly over WhatsApp with message broadcasting.",
        image: {
          desktop: "/assets/images/telegram-payments-user-targeting.png",
          mobile: "/assets/images/telegram-payments-user-targeting.png",
        },
        type: FeaturesSection.CARD_TYPES.VERTICAL,
      },
      {
        icon: "/assets/icons/wallet.svg",
        title: "Payment link",
        description:
          "Easy-to-share payment links with full payment integration for your telegram channel",
        image: {
          desktop: "/assets/images/telegram-payments-payment-link.png",
          mobile: "/assets/images/telegram-payments-payment-link.png",
        },
        type: FeaturesSection.CARD_TYPES.RECTANGLE,
      },
      {
        icon: "/assets/icons/lightning.svg",
        title: "On-demand payouts",
        description:
          "Get your money in your bank whenever you want with a click",
        image: {
          desktop: "/assets/images/telegram-payments-earnings.png",
          mobile: "/assets/images/telegram-payments-earnings-mobile.png",
        },
        type: FeaturesSection.CARD_TYPES.HORIZONTAL,
      },
      {
        icon: "/assets/icons/activity.svg",
        title: "Analytics",
        description:
          "Learn from the advance analytics how your audience is growing",
        image: {
          desktop: "/assets/images/telegram-payments-analytics.png",
          mobile: "/assets/images/telegram-payments-analytics-mobile.png",
        },
        type: FeaturesSection.CARD_TYPES.HORIZONTAL,
      },
    ],
  },
  reviews: {
    heading: (
      <span className="font-bold">
        <span className="font-extrabold">1000+</span> creators love us
      </span>
    ),
    items: [
      {
        creatorName: "SMT Sebi Registered",
        creatorImage: "/assets/images/testimonial-smt.png",
        creatorReview:
          "“When it comes to scaling up your business, operations automation is the foremost requirement, and this won't be possible without a dedicated, supportive, and responsive team. And the qoohoo team is doing a really fantastic remarkable job. Thanks qoohoo for your support.”",
        image: "/assets/images/telegram-payments-automation.png",
      },
      {
        creatorName: "Exam Tak Hindi",
        creatorImage: "/assets/images/testimonial-examtak.png",
        creatorReview:
          "Hi, I'm using qoohoo since last 4 months & my experience is amazing with it. I save a lot of time because qoohoo's automation works smoothly, and the support team is also very helpful. Overall, after I started using qoohoo, my revenue increased drastically. Thanks again.",
        image: "/assets/images/telegram-payments-growth.png",
      },
      {
        creatorName: "Nipun - Your Competitive Mentor",
        creatorImage: "/assets/images/testimonial-nipun.png",
        creatorReview:
          "We have been using qoohoo service since 1 year.. it has been an amazing and seamless experience with service. Customer support is very quick to respond. That helps us to solve any problems that we face in no time. Thank you, qoohoo! 🤝 🤝",
        image: "/assets/images/telegram-payments-support.png",
      },
      {
        creatorName: "Mahesh - Exam Oriented Academy",
        creatorImage: "/assets/images/testimonial-mahesh.png",
        creatorReview:
          "Nice app. One stop solution to my needs. Now students can easily join my telegram group without any involvement from my side. Thank you qoohoo",
        image: "/assets/images/telegram-payments-share-card.png",
      },
    ],
  },
  faqs: {
    heading: "FAQs",
    items: faqs,
  },
  footerWavePath: "/assets/images/telegram-footer-wave.svg",
  theme: {
    isDark: false,
    backgroundColor: "#FFFFFF",
    accentColor: "#2AABEE",
    textColor: "#16191B",
    process: {
      backgroundColor: "#7CD0FE",
    },
    features: {
      cardBackgroundColor: "#F6F6F6",
    },
    reviews: {
      reviewBackgroundColor: "#AEE3FF",
    },
    faq: {
      questionBackgroundColor: "#EBF2FB",
      answerBackgroundColor: "#F8FBFF",
    },
    footer: {
      backgroundColor: "#7CD0FE",
    },
  },
};

const TelegramPayments = ProductPagesHOC(pageConfig);

export default TelegramPayments;
